// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RTtp","colMin":"styles_colMin__3GFLN"};